export const DESIGN_06 = {
 "blocks": [
    {
      "blockType": "NAVBAR",
      "blockDesign": "NavDesign1",
      "editFormName": "NAVBAR_FORM_1",
      "styleProps": {
        "background-color": "#ffffff"
      },
      "logoType": "text",
      "logoImg": {
        "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
        "altText": "FlexBee",
        "styleProps": {
          "height": "3rem"
        }
      },
      "logoText": {
        "text": "Homic",
        "styleProps": {
          "font-size": "1.875rem",
          "color": "#333333",
          "font-family": "'Old Standard TT'",
          "line-height": "2.25rem",
          "font-family-bk": "'Lato', sans-serif",
          "font-weight": "900",
          "font-family-cust": " Old Standard TT"
        },
        "stylePropsMob": {},
        "stylePropsTab": {}
      },
      "logoHTML": {
        "html": "FlexBee",
        "styleProps": {
          "font-size": "1.875rem",
          "color": "#ffffff",
          "font-family": "'Oswald', sans-serif",
          "line-height": "2.25rem"
        },
        "stylePropsMob": {},
        "stylePropsTab": {}
      },
      "links": [
        {
          "text": "Features",
          "linkUrl": "/features",
          "styleProps": {
            "color": ""
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Services",
          "linkUrl": "/services",
          "styleProps": {
            "color": ""
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Docs",
          "linkUrl": "/docs",
          "styleProps": {
            "color": ""
          },
          "sectionID": "aboutsection"
        },
        {
          "text": "Blog",
          "linkUrl": "/home",
          "sectionID": "aboutsection",
          "styleProps": {
            "color": "",
            "margin": "0px 0px 0px 120px"
          }
        },
        {
          "text": "Get Started",
          "linkUrl": "/home",
          "sectionID": "aboutsection",
          "styleProps": {
            "color": "#ffffff",
            "border-width": "0px",
            "border-radius": "9999px",
            "padding": "14px 30px 14px 30px",
            "margin": "0px 0px 0px 20px",
            "border-color": "#4f4f4f",
            "background-color": "#333333"
          }
        }
      ],
      "hamburgerStyleProps": {
        "color": "#333333",
        "border-color": "#333333"
      },
      "metaDataId": 1748050201026,
      "afterIndex": 0,
      "blockId": 1748050201026,
      "linksStyleProps": {
        "color": "#333333",
        "padding": "14px 0px 14px 0px",
        "font-weight": "600",
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "fonts": {
        "logoText": " Old Standard TT"
      },
      "textBlock": {
        "headings": [
          {
            "text": "Join our community and thrive with us! We can all help each other, learn together, and grow together.",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#ffffff",
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 10px 0px",
              "padding": "10px 0px 10px 0px"
            }
          },
          {
            "text": "Join our community and thrive with us! We can all help each other, learn together, and grow together.",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#ffffff",
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 10px 0px",
              "padding": "10px 0px 10px 0px"
            }
          },
          {
            "text": "Join our community and thrive with us! We can all help each other, learn together, and grow together.",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#ffffff",
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 10px 0px",
              "padding": "10px 0px 10px 0px"
            }
          },
          {
            "text": "Join our community and thrive with us! We can all help each other, learn together, and grow together.",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#ffffff",
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 10px 0px",
              "padding": "10px 0px 10px 0px"
            }
          },
          {
            "text": "Join our community and thrive with us! We can all help each other, learn together, and grow together.",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#ffffff",
              "font-size": "1.125rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 10px 0px",
              "padding": "10px 0px 10px 0px"
            }
          }
        ]
      }
    },
    {
      "blockType": "HEADER",
      "blockDesign": "HeaderDesign2",
      "editFormName": "HEADER_04_FORM",
      "styleProps": {
        "background-image": "linear-gradient(to right,#fef3ee,#febac9)",
        "background-color": "#ffffff",
        "padding": "40px 20px 40px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#cccccc"
      },
      "textBlock": {
        "styleProps": {
          "background-color": "",
          "border-radius": "0",
          "padding": "10px 10px 10px 10px"
        },
        "stylePropsTab": {},
        "stylePropsMob": {},
        "alingBlock": "center",
        "headings": [
          {
            "text": "{{name}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "red",
              "height": "4px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "3.75rem",
              "line-height": "1",
              "font-weight": "400",
              "font-family-cust": "Source Serif 4",
              "font-family": "'Source Serif 4'",
              "font-family-bk": "'Source Serif 4', cursive"
            },
            "alignStyleProps": {
              "text-align": "left",
              "margin": "10px 0px 40px 0px",
              "padding": "10px 20px 10px 20px"
            },
            "stylePropsMob": {
              "font-size": "2.25rem",
              "line-height": "2.5rem"
            },
            "stylePropsTab": {
              "font-size": "3.75rem",
              "line-height": "1"
            }
          },
          {
            "text": "{{role}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "1.5rem",
              "line-height": "2rem",
              "padding": "0px 0px 0px 0px",
              "font-weight": "600"
            },
            "alignStyleProps": {
              "text-align": "left",
              "padding": "0px 20px 0px 20px",
              "margin": "0px 0px 10px 0px"
            },
            "stylePropsMob": {
              "font-size": "1.25rem",
              "line-height": "1.75rem"
            }
          },
          {
            "text": "{{description}}",
            "hideUnderline": false,
            "underLineStyle": {
              "background-color": "yellow",
              "height": "2px"
            },
            "styleProps": {
              "color": "#333333",
              "font-size": "1.5rem",
              "line-height": "1.75rem"
            },
            "alignStyleProps": {
              "text-align": "left",
              "padding": "0px 20px 0px 20px"
            }
          }
        ],
        "dynamicText": {
          "styleProps": {
            "color": "#ffffff",
            "font-size": "1.875rem",
            "line-height": "2.25rem",
            "padding": "10px 0px 10px 0px",
            "text-align": "center"
          },
          "stylePropsTab": {
            "padding": "10px 0px 10px 0px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "stylePropsMob": {
            "padding": "10px 0px 10px 0px",
            "font-size": "1.5rem",
            "line-height": "2rem"
          },
          "strings": []
        },
        "descriptionsStyleProps": {
          "padding": "10px 0px 10px 0px",
          "text-align": "center",
          "margin": "0px 0px 0px 0px"
        },
        "descriptionsStylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "descriptionsStylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "descriptions": [],
        "buttonsStyleProps": {
          "margin": "50px 0px 0px 0px"
        },
        "buttonAlign": "start",
        "buttons": [
          {
            "styleProps": {
              "padding": "10px 40px 10px 40px",
              "border-width": "0px",
              "color": "#ffffff",
              "background-color": "#333333",
              "border-radius": "9999px"
            },
            "alt": "Google Play Store",
            "href": "#",
            "text": "Contact ",
            "openType": "sametab"
          },
          {
            "styleProps": {
              "padding": "10px 40px 10px 40px",
              "color": "#333333",
              "background-color": "#ffffff",
              "border-width": "1px",
              "border-color": "#808080",
              "border-radius": "9999px"
            },
            "alt": "Apple App Store",
            "href": "#",
            "text": "Explore Works",
            "openType": "sametab"
          }
        ],
        "emailSecStyleProps": {},
        "subscription": {
          "showSection": "hide",
          "display": "enable",
          "subConfigs": {
            "configType": "convertkit",
            "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
            "configPlaceholder": ""
          },
          "email_placeholder": {
            "text": "example@mail.com"
          },
          "buttonText": {
            "text": "Subscribe",
            "styleProps": {
              "background-color": "#1b1b31",
              "color": "#ffffff"
            }
          },
          "successMessage": {
            "text": "Thank you for the signup",
            "styleProps": {}
          },
          "errorMessage": {
            "text": "Something went wrong. Please try again.",
            "styleProps": {}
          }
        }
      },
      "imageType": "image",
      "imageVideoPostion": "right",
      "imageBlock": {
        "image": "{{img}}",
        "styleProps": {
          "margin": "20px 20px 20px 20px",
          "border-color": "",
          "border-width": "0px"
        },
        "tagStyleProps": {
          "border-radius": "3.5rem",
          "border-width": "8px",
          "border-color": "#ffffff",
          "box-shadow": "8px 8px 2px 0px rgb(0 0 0 / 1)"
        }
      },
      "videoBlock": {
        "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
        "styleProps": {
          "margin": "20px 20px 20px 20px"
        },
        "videoHeight": {
          "height": "400px"
        }
      },
      "htmlBlock": {
        "value": "",
        "styleProps": {}
      },
      "metaDataId": 1747658985938,
      "afterIndex": -1,
      "blockId": 1747658985938,
      "buttons": [
        {
          "text": "Click Here",
          "styleProps": {
            "color": "#ffffff",
            "border-color": "#3b82f680"
          },
          "href": "#",
          "openType": "sametab"
        }
      ],
      "fonts": {
        "textBlock": "Source Serif 4"
      },
      "position": "hide",
      "stylePropsTab": {
        "padding": "30px 20px 30px 20px"
      },
      "stylePropsMob": {
        "padding": "20px 20px 20px 20px"
      },
      "containerStyleProps": {
        "max-width": "1152px"
      }
    },
    {
      "blockType": "HEADER",
      "blockDesign": "header_01",
      "styleProps": {
        "background-image": "url('')",
        "background-color": "#ffffff",
        "padding": "40px 20px 40px 20px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#cccccc"
      },
      "position": "center",
      "headingsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "headingsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "headingsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "headings": [
        {
          "styleProps": {
            "font-size": "3.75rem",
            "line-height": "1",
            "padding": "20px 0px 40px 0px",
            "font-weight": "400",
            "color": "#333333",
            "font-family-cust": "Playfair Display",
            "font-family": "'Playfair Display'",
            "margin": "0px 0px 0px 0px",
            "font-family-bk": "'Playfair Display', serif"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1",
            "padding": "20px 0px 20px 0px"
          },
          "stylePropsMob": {
            "font-size": "2.25rem",
            "line-height": "2.5rem",
            "padding": "20px 0px 20px 0px"
          },
          "text": "About"
        },
        {
          "text": "{{content}}",
          "styleProps": {
            "font-size": "1.5rem",
            "line-height": "2rem",
            "color": "#333333",
            "margin": "0px 0px 40px 0px"
          },
          "stylePropsMob": {
            "font-size": "1rem",
            "line-height": "1.5rem"
          },
          "alignStyleProps": {
            "max-width": "896px",
            "margin": "0px auto 0px auto"
          }
        }
      ],
      "dynamicText": {
        "styleProps": {
          "font-size": "1.875rem",
          "line-height": "2.25rem",
          "padding": "10px 0px 10px 0px",
          "text-align": "center"
        },
        "stylePropsTab": {
          "padding": "10px 0px 10px 0px"
        },
        "stylePropsMob": {
          "padding": "10px 0px 10px 0px"
        },
        "strings": []
      },
      "descriptionsStyleProps": {
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "descriptionsStylePropsTab": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptionsStylePropsMob": {
        "padding": "10px 0px 10px 0px"
      },
      "descriptions": [
        {
          "text": "✸ Status : {{status}}",
          "styleProps": {
            "font-size": "1.125rem",
            "line-height": "1.75rem",
            "color": "#333333",
            "font-weight": "500"
          }
        }
      ],
      "buttonsStyleProps": {},
      "buttons": [],
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "textsStyleProps": {
        "text-align": "center"
      },
      "texts": [
        {
          "type": "el",
          "sub_type": "html",
          "text": "Want to use a web browser? <a href='#'>Log in to Gusto</a>"
        }
      ],
      "editFormName": "HEADER_FORM_01",
      "metaDataId": 1747659868137,
      "afterIndex": -1,
      "blockId": 1747659868137,
      "textBlock": {
        "descriptions": [
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          },
          {
            "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            "styleProps": {
              "font-size": "1.125rem",
              "line-height": "1.75rem",
              "color": "#ffffff"
            }
          }
        ],
        "headings": [
          {},
          {}
        ]
      },
      "fonts": {
        "headings": [
          "Playfair Display"
        ]
      },
      "stylePropsMob": {
        "padding": "30px 14px 30px 14px"
      },
      "stylePropsTab": {
        "padding": "40px 20px 40px 20px"
      },
      "containerStyleProps": {
        "max-width": "1024px"
      }
    },
    {
      "blockType": "CTA",
      "blockDesign": "CTADesign1",
      "editFormName": "CTA_01_FORM",
      "styleProps": {
        "background-color": "#ffffff",
        "padding": "40px 0px 40px 0px"
      },
      "headings": [
        {
          "text": "Explore More Top Developers\n",
          "styleProps": {
            "text-align": "center",
            "font-size": "3.75rem",
            "line-height": "1",
            "padding": "50px 0px 30px 0px",
            "color": "#333333",
            "font-family-cust": "Source Serif 4",
            "font-family": "'Source Serif 4'",
            "font-family-bk": "'Nunito', sans-serif"
          },
          "alignStyleProps": {
            "text-align": "center"
          },
          "stylePropsTab": {
            "font-size": "3rem",
            "line-height": "1"
          },
          "stylePropsMob": {
            "font-size": "2.25rem",
            "line-height": "2.5rem"
          }
        },
        {
          "text": "Discover more talented developers who can bring your projects to life. Browse our curated list of experts in various technologies and industries.",
          "styleProps": {
            "text-align": "center",
            "padding": "10px 0px 10px 0px",
            "color": "#333333",
            "font-size": "1.25rem",
            "line-height": "1.75rem",
            "margin": "0px 0px 40px 0px",
            "border-color": ""
          },
          "alignStyleProps": {
            "text-align": "center"
          }
        }
      ],
      "showBtnSec": true,
      "btnSecStyleProps": {},
      "btnSecStylePropsTab": {},
      "btnSecStylePropsMob": {},
      "buttons": [
        {
          "text": "➤ View More Developers",
          "alt": "Click Here",
          "href": "https://yahoo.com",
          "styleProps": {
            "background-color": "#333333",
            "color": "#ffffff",
            "border-color": "#3b82f680",
            "border-radius": "9999px",
            "padding": "14px 40px 14px 40px",
            "border-width": "0px"
          },
          "openType": "sametab"
        },
        {
          "text": "Explore Our Talent Pool",
          "styleProps": {
            "color": "#333333",
            "border-color": "#333333",
            "background-color": "",
            "border-width": "1px",
            "border-radius": "9999px",
            "padding": "14px 40px 14px 40px"
          },
          "href": "",
          "openType": "sametab"
        }
      ],
      "showEmailSec": true,
      "emailSecStyleProps": {},
      "subscription": {
        "showSection": "hide",
        "display": "enable",
        "subConfigs": {
          "configType": "convertkit",
          "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
          "configPlaceholder": ""
        },
        "email_placeholder": {
          "text": "example@mail.com"
        },
        "buttonText": {
          "text": "Subscribe",
          "styleProps": {
            "background-color": "#1b1b31",
            "color": "#ffffff"
          }
        },
        "successMessage": {
          "text": "Thank you for the signup",
          "styleProps": {}
        },
        "errorMessage": {
          "text": "Something went wrong. Please try again.",
          "styleProps": {}
        }
      },
      "metaDataId": 1747660197695,
      "afterIndex": 5,
      "blockId": 1747660197695,
      "containerStyleProps": {
        "padding": "0px 20px 0px 20px",
        "max-width": "998px"
      },
      "containerStylePropsTab": {
        "padding": "0px 0px 0px 0px"
      },
      "fonts": {
        "headings": [
          "Source Serif 4"
        ]
      },
      "stylePropsMob": {
        "padding": "30px 0px 30px 0px"
      }
    }
  ]
}